import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { TeamExpertText, TeamExpertTitle } from "../../Constants/Constants";
import { IconGoogleData, TeamExpertData } from "../../Data/Landing/Landing";
import { TeamExpertSettingsData } from "../../Data/Messenger/Messenger";
import { dynamicImage, Image } from "../../Utils";

const TeamExpert = () => {
  return (
    <section className="section-py-space our-experts">
      <div className="custom-container">
        <Row>
          <Col xs="12">
            <div className="content-title">
              <h3>{TeamExpertTitle}</h3>
              <h2>{TeamExpertText}</h2>
              <span />
            </div>
          </Col>
          <Col xs="12" className="testimonial-main">
            <div className="experts-slider pt-0">
              <Swiper {...TeamExpertSettingsData} className="mySwiper">
                {TeamExpertData.map((item, index) => (
                  <SwiperSlide className="experts-box mt-0" key={index}>
                    <div className="test-img">
                      <div><Image className="img-fluid" src={dynamicImage(`about/${item}.png`)} alt="test-img" /></div>
                    </div>
                    <div className="test-contain">
                      <h4>project manager</h4>
                      <h3>Advanced Equipment</h3>
                      <h6>I would suggest you discuss this further with the advertising team.</h6>
                      <ul className="test-icon">
                        {IconGoogleData.map((item, index) => (
                          <li key={index}>
                            <Link to={item} target="_blank">
                              <Image className="img-fluid" src={dynamicImage(`landing/testimonial/icon${index + 1}.png`)} alt="icon-google" />
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default TeamExpert;
